import { Pejabat } from "./pejabat";

export const PEJABAT: Pejabat[] = [
    {id: 1, name: 'Suminto'},
    {id: 2, name: 'Ubaidi Socheh Hamidi'},
    {id: 3, name: 'Syurkani Ishak Kasim'},
    {id: 4, name: 'Deni Ridwan'},
    {id: 5, name: 'Dwi Irianti Hadiningdyah'},
    {id: 6, name: 'Brahmantio Isdijoso'},
    {id: 7, name: 'Endah Martiningrum'},
    {id: 8, name: 'Riko Amir'},
    {id: 9, name: 'Heri Setiawan'}
]


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/mock-pejabat.ts